import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import cn from '@/utils/cn';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { SlideGroup } from '@/components/admin/SlideShow/Builder/CreateTransistionGroup/utils';
import TransitionSlide from '../../PresentMode/TransitionSlide';
import builderStyles from '../SlideShowBuilder.module.scss';
import styles from './SlidePanel.module.scss';
import SlideGroupCardActions from './SlideGroupCardActions';
import { makeDraggableId } from './slideReorder';

interface SlideGroupCardProps {
  card: SlideGroup;
  groupIndex: number;
  index: number;
  isFinal: boolean;
  isSelected: boolean;
  transitionCards: SlideGroup[];
  onSelect: () => void;
}

const SlideGroupCard = ({
  card,
  groupIndex,
  index,
  isFinal,
  isSelected,
  transitionCards,
  onSelect,
}: SlideGroupCardProps) => {
  const imageUrl = useSlideShowContext(state => state.slideShow.imageUrl);
  const locale = useSlideShowContext(state => state.locale);
  const title = (locale === 'es' && card.titleEs) || card.titleEn;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') onSelect();
  };

  return (
    <Draggable isDragDisabled draggableId={makeDraggableId('group', card.id)} index={index}>
      {draggable => (
        <div
          ref={draggable.innerRef}
          {...draggable.draggableProps}
          {...draggable.dragHandleProps}
          aria-label={title}
          className={builderStyles.dragContainer}
          role="button"
          tabIndex={0}
          onClick={onSelect}
          onKeyDown={handleKeyDown}
        >
          <div className={cn(styles.thumbnailWrapper, styles.pointer)}>
            {/* Block wrapper: the position number sits above the slide, which .adjusted then pulls up over it. */}
            <div className={cn(builderStyles.fullWidthMax, { [builderStyles.selected]: isSelected })}>
              {!isFinal && <SlideGroupCardActions card={card} />}
              <span className={styles.positionNumber}>{card.position}</span>
              <TransitionSlide
                className={cn(styles.overflowHidden, styles.noPointerEvents, styles.adjusted)}
                forDisplay="thumbnail"
                imageUrl={imageUrl}
                isSelected={isSelected}
                jumpToSlide={() => {}}
                slideGroupIndex={groupIndex}
                slideGroups={transitionCards}
              />
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default SlideGroupCard;
